<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11 26.51a1.48 1.48 0 01-.74-.19A1.51 1.51 0 019.5 25V7a1.51 1.51 0 01.76-1.31 1.53 1.53 0 011.51 0l15 9a1.5 1.5 0 010 2.58l-15 9a1.49 1.49 0 01-.77.24zm.5-18.64v16.26L25 16zm14.24 8.56zm0 0z"/></svg>